import React from 'react';
import PropTypes from 'prop-types';
import Alert from './Alert';
const ErrorAlert = ({ title, canClose, onClose, children }) => (React.createElement(Alert, { type: "error", title: title, canClose: canClose, onClose: onClose }, children));
ErrorAlert.propTypes = {
    title: PropTypes.string,
    children: PropTypes.any,
    canClose: PropTypes.bool,
    onClose: PropTypes.func,
};
ErrorAlert.defaultProps = {
    canClose: false,
    onClose: () => { },
};
export default ErrorAlert;
